import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import classes from "./SubscriptionPage.module.css";
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import SmallLoader from '../components/Loaders/SmallLoader';
import OTPInput from "react-otp-input";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaCheck } from "react-icons/fa";
// import { getPacks } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
// import { SendOtpAPI } from '../http/http';
import { setUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import TermsModal from '../components/TermsModal';
import { login, sendOTPApi } from '../http/http';
import AutoRenewalModal from '../components/AutoRenewModal';
// import { sendOTPApi, subscribeApi } from '../http/http';

const SubscriptionPage = () => {
    const { t } = useTranslation();
    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(false);
    const [extRef, setExtRef] = useState(null);
    const [termsModal, setTermsModal] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const [autoRenewal, setAutoRenewal] = useState(false);

    const toggleSwitch = () => setAutoRenewal(!autoRenewal)

    const [modal, setModal] = useState(false);


    const [pack, setPack] = useState("Daily");

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { userToken } = useSelector(state => state.persisted.userTokenSlice);

    useEffect(() => {
        if (userToken) {
            navigate("/home");
        }
    }, [userToken]);

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const handleFormSubmission = async (e) => {
        e.preventDefault();

        try {
            if (msisdn?.trim().length == 0) {
                return;
            }

            let msisdnWithCountryCode = msisdn?.toString().trim().replace(/\D/g, '');

            if (msisdnWithCountryCode.startsWith('0')) {
                msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
            }

            if (!msisdnWithCountryCode.startsWith('236')) {
                msisdnWithCountryCode = '236' + msisdnWithCountryCode;
            }

            setLoading(true);

            const response = await sendOTPApi(msisdnWithCountryCode, pack, extRef);
            console.log(response, 'response...');
            // console.log(response?.data, 'data 1')
            // console.log(response?.data?.data, 'data2 ');
            // console.log(response?.data?.data?.referenceNo);

            setLoading(false);
            navigate("/otp", {
                state: {
                    msisdn: msisdnWithCountryCode,
                    pack,
                    extRef
                }
            })

        } catch (error) {
            console.log(error, 'error---');
            if (error?.response?.data?.status == 1) {
                toast.error(t("126"));
            }
            else if (error?.response?.data?.status == 0) {
                // hit here login api please
                // toast.error(t("94"))

                let msisdnWithCountryCode = msisdn?.toString().trim().replace(/\D/g, '');

                if (msisdnWithCountryCode.startsWith('0')) {
                    msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
                }

                if (!msisdnWithCountryCode.startsWith('236')) {
                    msisdnWithCountryCode = '236' + msisdnWithCountryCode;
                }

                await login({ msisdn: msisdnWithCountryCode })
                    .then((res) => {
                        dispatch(setUserToken(res?.data?.result?.token));
                        navigate("/home");
                        toast.success(t("84"));
                    })
                    .catch((err) => {
                        if (err?.response?.data?.error?.status == 1) {
                            navigate("/low-balance");
                        }
                        else {
                            toast.error(t("86"));
                        }
                    });
            }
            else {
                toast.error(t("86"));
            }
            setLoading(false);
        }
    }

    return (
        <>
            <Header />

            <div className={classes.container}>
                <h1 className={classes.heading}>
                    <span style={{ color: '#3550dc' }}>Quiz Masters</span>{" "}{t("59")}
                </h1>
                <div className={classes.actions_box_container}>
                    <div className={classes.actions_box}>
                        <button className={`${classes.action_box}`}
                            type='button'
                            onClick={() => navigate(`/login?ext_id=${extRef}`)}>
                            {t("60")}
                        </button>
                        <button className={`${classes.action_box} ${classes.active}`}>
                            {t("61")}
                        </button>
                    </div>
                </div>


                <form className={classes.form} onSubmit={handleFormSubmission}
                >
                    <div className={classes.username_field_form}>
                        <div className={classes.country_code}>
                            <img src="/assets/images/central-african-republic.png" alt="flag" className={classes.flag} />
                            <p className={classes.country_code_number}>+236</p>
                        </div>
                        <input
                            id="msisdn"
                            name="msisdn"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            autoFocus placeholder={t("62")} className={classes.input_field_username}
                            onChange={(e) => {
                                setMsisdn(e.target.value)
                            }}
                            value={msisdn}
                        />
                    </div>

                    <div className={classes.packs}>
                        <p className={classes.packs_heading}>{t("63")}</p>

                        <button type='button' className={`${classes.pack_box} ${classes.shade_blue}`}
                            onClick={() => setPack("Daily")}
                        >
                            <span className={`${classes.pack_header} ${classes.shade_blue}`}>{t("119")}</span>
                            {
                                pack === "Daily" ?
                                    <div className={`${classes.checked_radio} ${pack === "Daily" && classes.shade_blue}`}>
                                        <FaCheck className={classes.checked_icon} />
                                    </div>
                                    : <div className={classes.dummy_radio}>

                                    </div>
                            }
                            <p className={`${classes.pack_price_point} ${classes.active}`}>
                                50 CFA{" "}/{" "}
                                {t("128")}
                            </p>
                        </button>

                        <button type='button' className={`${classes.pack_box} ${classes.shade_green}`}
                            onClick={() => setPack("Weekly")}
                        >
                            <span className={`${classes.pack_header} ${classes.shade_green}`}>{t("120")}</span>
                            {
                                pack === "Weekly" ?
                                    <div className={`${classes.checked_radio} ${pack === "Weekly" && classes.shade_green}`}>
                                        <FaCheck className={classes.checked_icon} />
                                    </div>
                                    : <div className={classes.dummy_radio}>

                                    </div>
                            }
                            <p className={`${classes.pack_price_point} ${classes.active}`}>
                                250 CFA {" "}/{" "}
                                {t("130")}
                            </p>
                        </button>

                    </div>

                    <div className={classes.check_box_container}>
                        <input type="checkbox" id="terms" name="Terms & Conditions" value="Terms"
                            className={classes.check_box} checked
                        >
                        </input>
                        <label for="terms" className={classes.check_box_label}>
                            {t("99")}{" "}<span className={classes.link} onClick={() => setTermsModal(true)}>{t("114")}</span>
                        </label>
                    </div>

                    <div className={classes.auto_renewal_container}>
                        <input type="checkbox" id="autoRenewal" name="Auto Renewal" value="Auto Renewal"
                            className={classes.check_box} checked={autoRenewal} onClick={toggleSwitch}
                        >
                        </input>
                        <label for="terms" className={classes.check_box_label}>
                            <span className={classes.link} onClick={() => setModal(true)}>{t("156")}</span>
                        </label>
                    </div>

                    <button type="submit"
                        disabled={loading}
                        className={classes.login_btn}>{
                            loading ? <SmallLoader style={{ border: "5px solid #fff" }} /> : t("61")
                        }</button>
                    <div className={classes.footer}>
                        <p><span>&copy;</span> Rainboo Softmate {new Date().getFullYear()}</p>
                    </div>
                </form>

            </div>

            {termsModal && <TermsModal setTermsModal={setTermsModal} />}
            {modal && <AutoRenewalModal setModal={setModal} />}

        </>
    )
}

export default SubscriptionPage